module.exports = __webpack_public_path__ + "static/logo-a1ffe4924460fc52f5eacb08bc7bcc23.svg";